<template>
  <div class="flex-container panel-head align-top mb-5" v-if="weighBridgeDetails">
    <div class="flex-item mb-10 wp-30">
        <InputSaveView
          :defaultValue="weighBridgeDetails.weigh_in_time"
          :hideEdit="hideEdit"
          :baseMinDate="orderDetails && orderDetails.sources && orderDetails.sources[0].arrived_at"
          :errorOnSave="errorOnSave && currentUpdatedTab === 'weigh_in_time'"
          :label="$t('INDENT_WEIGHT_IN_DATE_AND_TIME')"
          inputType="dateTime"
          @changeValue="saveWeighBridgeDetails($event,'weigh_in_time')">
        </InputSaveView>
        <InputSaveView
          :defaultValue="weighBridgeDetails.weigh_in_weight"
          :hideEdit="hideEdit"
          :errorOnSave="errorOnSave && currentUpdatedTab === 'weigh_in_weight'"
          :isSavingData="isSavingData && currentUpdatedTab === 'weigh_in_weight'"
          :label="$t('INDENT_WEIGHT_OF_VEHICLE_KG')"
          :placeholder="$t('INDENT_VEHICLE_WEIGHT_AT_WEIGH_IN')"
          @changeValue="saveWeighBridgeDetails($event,'weigh_in_weight')">
        </InputSaveView>
    </div>
    <div class="flex-item text-right wp-30 pl-0">
        <InputSaveView
          :defaultValue="weighBridgeDetails.weigh_out_time"
          :hideEdit="hideEdit"
          :disabled="!weighBridgeDetails.weigh_in_time"
          :baseMinDate="weighBridgeDetails.weigh_in_time"
          :errorOnSave="errorOnSave && currentUpdatedTab === 'weigh_out_time'"
          :label="$t('INDENT_WEIGHT_OUT_DATE_AND_TIME')"
          inputType="dateTime"
          @changeValue="saveWeighBridgeDetails($event,'weigh_out_time')">
        </InputSaveView>
        <InputSaveView
          :defaultValue="weighBridgeDetails.weigh_out_weight"
          :hideEdit="hideEdit"
          :errorOnSave="errorOnSave && currentUpdatedTab === 'weigh_out_weight'"
          :isSavingData="isSavingData && currentUpdatedTab === 'weigh_out_weight'"
          :label="$t('INDENT_WEIGHT_OF_VEHICLE_KG')"
          :placeholder="$t('INDENT_VEHICLE_WEIGHT_AT_WEIGH_OUT')"
          @changeValue="saveWeighBridgeDetails($event,'weigh_out_weight')">
        </InputSaveView>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InputSaveView from '@common/components/InputSaveView';

import { getDateDiffInDaysMins } from '@/lib/Date.js';

export default {
  data() {
    return {
      selectedLabel: false,
      weighBridgeDetails: {},
      currentOrderDetails: {},
      errorOnSave: false,
      currentUpdatedTab: null,
      isSavingData: false,
    };
  },
  components: {
    InputSaveView,
  },
  props: [
    'hideEdit',
    'orderDetails',
  ],
  created() {
    this.currentOrderDetails = this.orderDetails;
    if (this.orderDetails && this.orderDetails.weigh_bridge) {
      const orderWeighBridge = this.orderDetails.weigh_bridge;
      this.weighBridgeDetails = {
        weigh_in_time: orderWeighBridge.weigh_in_time,
        weigh_out_time: orderWeighBridge.weigh_out_time,
        weigh_in_weight: orderWeighBridge.weigh_in_vehicle_weight,
        weigh_out_weight: orderWeighBridge.weigh_out_vehicle_weight,
      };
    }
  },
  computed: {
    canShowEditView() {
      return this.selectedLabel;
    },
  },
  methods: {
    showEditView(label) {
      if (!this.selectedLabel) {
        this.selectedLabel = label;
        this.enteredValue = this.weighBridgeDetails && this.weighBridgeDetails[label];
      }
    },
    closeEditView() {
      this.showActionsLabel = null;
      this.enteredConsgtNumber = null;
    },
    async saveWeighBridgeDetails(data, label) {
      this.isSavingData = true;
      const tempWeighBridgeDetails = Object.assign({}, this.weighBridgeDetails);
      tempWeighBridgeDetails[label] = data;
      await this.saveDetails(label, tempWeighBridgeDetails);
      this.isSavingData = false;
    },
    async saveDetails(currentUpdatedTab, tempWeighBridgeDetails) {
      this.currentUpdatedTab = currentUpdatedTab;
      try {
        const orderId = this.orderDetails.order_number;
        const data = {};
        if (tempWeighBridgeDetails.weigh_in_time) {
          if (getDateDiffInDaysMins(tempWeighBridgeDetails.weigh_in_time, this.orderDetails.sources[0].arrived_at).diff < 0) {
            this.validationError('Weigh in time should be greater then truckin time');
            return;
          }
          data.weigh_in_time = this.$moment(tempWeighBridgeDetails.weigh_in_time);
        }
        if (tempWeighBridgeDetails.weigh_out_time) {
          if (getDateDiffInDaysMins(tempWeighBridgeDetails.weigh_out_time, tempWeighBridgeDetails.weigh_in_time).diff < 0) {
            this.validationError('Weigh out time should be greater then weigh in time');
            return;
          }
          data.weigh_out_time = this.$moment(tempWeighBridgeDetails.weigh_out_time);
        }
        if (tempWeighBridgeDetails.weigh_in_weight) {
          if (tempWeighBridgeDetails.weigh_in_weight < 0) {
            this.validationError('Weigh in weight should be greater than 0');
            return;
          }
          data.weigh_in_vehicle_weight = parseFloat(tempWeighBridgeDetails.weigh_in_weight).toFixed(2);
        }
        if (tempWeighBridgeDetails.weigh_out_weight) {
          if (tempWeighBridgeDetails.weigh_out_weight < 0) {
            this.validationError('Weigh out weight should be greater than 0');
            return;
          }
          data.weigh_out_vehicle_weight = parseFloat(tempWeighBridgeDetails.weigh_out_weight).toFixed(2);
        }
        const result = await this.$store.dispatch('order/saveWeighBridgeDetails', {
          orderId,
          data,
        });
        if (!result) {
          this.validationError('Update failed');
        } else if (result.error) {
          this.validationError(result.error);
        } else {
          this.errorOnSave = false;
          this.updateWeighBridgeDetails(data);
          this.currentOrderDetails = data;
          this.$success({ message: 'Update successful' });
        }
      } catch (error) {
        this.validationError('Update failed');
        this.isSavingData = false;
      }
    },
    validationError(message) {
      this.errorOnSave = true;
      this.updateWeighBridgeDetails(this.currentOrderDetails.weigh_bridge); // added for outside click and continous update
      this.$errorMessage({ message });
    },
    updateWeighBridgeDetails(orderWeighBridge) {
      if (orderWeighBridge) {
        this.weighBridgeDetails = {
          weigh_in_time: orderWeighBridge.weigh_in_time,
          weigh_out_time: orderWeighBridge.weigh_out_time,
          weigh_in_weight: orderWeighBridge.weigh_in_vehicle_weight,
          weigh_out_weight: orderWeighBridge.weigh_out_vehicle_weight,
        };
      }
    },
  },
};
</script>
